module.exports = __webpack_public_path__ + "static/img/Audi-door.3fcffc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Audi-door.jpg
// module id = 39lo
// module chunks = 11